import { BoxProps } from '@mui/material';

export const menuRightStyle: BoxProps = {
  className: 'shrink-0 sm:ml-auto',
  sx: {
    display: 'block',

    // FORZATURA PER CODICE VECCHIO (Selettore Universale Adiacente)
    // Cerca qualsiasi elemento che contiene un bottone e si trova DOPO un altro elemento dello stesso tipo.
    // Funziona anche se i bottoni sono dentro NavLink, IsTenantAdministrator o div generici.
    '& * + *': {
      '& .MuiButton-root': {
        marginLeft: '12px !important' // Forza il distanziamento tra i bottoni isolati
      }
    },

    // DISATTIVAZIONE COSTRUTTO BUTTONGROUP (Se presente nel codice vecchio)
    // Se c'è un ButtonGroup, MUI resetta i margini e unisce i bordi. Lo disattiviamo forzatamente.
    '& .MuiButtonGroup-root': {
      display: 'flex',
      gap: 1, // Distanzia i blocchi dentro il ButtonGroup
      boxShadow: 'none',
      '& .MuiButtonGroup-grouped': {
        borderRadius: '8px !important', // Ripristina i bordi arrotondati dei singoli bottoni
        borderRightColor: '#1d70b8 !important', // Ripristina il bordo destro che il ButtonGroup cancella
        border: '1px solid #1d70b8 !important' // Forza la visualizzazione del bordo completo
      }
    },

    '& .MuiButton-root': {
      textTransform: 'none',

      fontFamily: 'Roboto, sans-serif',
      fontWeight: 500,
      fontSize: '14px',
      lineHeight: '1.2', // 120%
      letterSpacing: '0em',
      color: '#ffffff',
      height: '40px',
      boxShadow: 'none',
      whiteSpace: 'nowrap',
      minWidth: 'max-content',
      transition: 'all 0.2s ease-in-out',

      '&.MuiButton-outlined': {
        backgroundColor: '#1d70b8',
        color: '#ffffff',
        borderRadius: 2,
        '&:hover': {
          backgroundColor: '#155a96',
          boxShadow: 'none'
        },
        '& .MuiButton-startIcon': {
          fontSize: 'small',
          color: '#ffffff',
          marginRight: '6px'
        },
        '& .MuiTypography-root': {
          color: '#ffffff'
        }
      },

      '&.MuiButton-text': {
        backgroundColor: 'transparent',
        borderRadius: 0,
        '&:hover': {
          backgroundColor: 'rgba(0, 109, 176, 0.04)',
          textDecoration: 'underline'
        },
        '& .MuiButton-startIcon': {
          color: '#006DB0'
        },
        '& .MuiTypography-root': {
          color: '#006DB0'
        }
      },

      '&.MuiButton-contained': {
        backgroundColor: '#1d70b8',
        color: '#ffffff',
        borderRadius: 2,
        border: '1px solid #1d70b8',
        '&:hover': {
          backgroundColor: '#155a96',
          borderColor: '#155a96',
          boxShadow: 'none'
        },
        '& .MuiButton-startIcon': {
          fontSize: 'small',
          color: '#ffffff',
          marginRight: '6px'
        },
        '& .MuiTypography-root': {
          color: '#ffffff'
        }
      }
    },

    '& .MuiButton-startIcon': {
      transition: 'color 0.2s ease-in-out',
      marginRight: '6px'
    },

    '& .MuiTypography-root': {
      fontFamily: 'Roboto, sans-serif',
      fontWeight: 500,
      fontSize: '13px',
      lineHeight: '1.2', // 120%
      letterSpacing: '0em',
      textTransform: 'none',
      color: '#ffffff'
    }
  }
};
